import scaleReliabilityPercent, { needsReliabilityScaling } from "./scaleReliabilityPercent";

import { isSuprathresholdBehaviour } from "@/utils/TestUtils";

export default function getFnFpError(entry, type, presetValues = null) {
  if (presetValues && presetValues.hasOwnProperty(type)) {
    return presetValues[type];
  }
  if (!entry["fpFnInfo"]) {
    return "";
  }
  const inf = entry["fpFnInfo"][type];
  if (!inf) {
    return 0;
  }
  const rawPercent = Math.round((inf["val"] / inf["total"]) * 100) || 0;
  if (
    !isSuprathresholdBehaviour(entry["testBehaviour"]) ||
    !needsReliabilityScaling(entry["version"])
  ) {
    return rawPercent;
  }
  return scaleReliabilityPercent(rawPercent);
}

export function formatFalseNegativeError(entry, presetValues = null): string {
  const hasPresetValue = presetValues && presetValues.hasOwnProperty("fn");

  if (!hasPresetValue && !Number(entry?.fpFnInfo?.fn?.total)) {
    return "N/A";
  }

  return `${getFnFpError(entry, "fn", presetValues)}%`;
}

export function getFnFpRawRatio(entry, type, presetValues = null): string | null {
  if (presetValues && presetValues.hasOwnProperty(type)) {
    return null;
  }
  const inf = entry?.fpFnInfo?.[type];
  const val = Number(inf?.val);
  const total = Number(inf?.total);
  if (!Number.isFinite(val) || !Number.isFinite(total) || total <= 0) {
    return null;
  }
  const rawPercent = Math.round((val / total) * 100);
  if (getFnFpError(entry, type) !== rawPercent) {
    return null;
  }
  return `${val}/${total}`;
}

export function formatFnFpErrorWithRawRatio(entry, type, presetValues = null): string {
  const percentLabel =
    type === "fn"
      ? formatFalseNegativeError(entry, presetValues)
      : `${getFnFpError(entry, type, presetValues)}%`;
  const ratio = getFnFpRawRatio(entry, type, presetValues);
  return ratio ? `${percentLabel} (${ratio})` : percentLabel;
}
